module.exports = __webpack_public_path__ + "img/carton-quota.4be1b1b9.png";